import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Observable } from 'knockout';
import events from 'managers/events';
import overlayManager from 'managers/overlay';
import { EffectsContainer } from 'mixins/withEffects';
import { CommunityNavigationWidgetLayoutVMConfig } from './layout/layout';
import CommunityNavigationWidgetVM from './navigation';
import './settings.html';

components.registerLocal('community-navigation-layout', () => require('./layout/layout'));

@injectable()
export default class CommunityNavigationWidgetSettingsVM {
    isUserLoggedIn: Observable<boolean>

    constructor(
        @inject(wccModules.componentConfig) private widget: CommunityNavigationWidgetVM,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.effects) private effects: EffectsContainer
    ) {
        this.isUserLoggedIn = widget.model.isUserLoggedIn;

        ko.applyBindingsToNode(info.element, {
            'css': {
                'community-navigation__settings': true
            }
        });
    }

    editLayout = () => {
        this.effects.register(async () => {
            const stage = await overlayManager.toOverlay({ id: 'wcc-components-community-navigation-settings-layout-dialog' }, {
                data: stage => ({
                    layoutEditor: <CommunityNavigationWidgetLayoutVMConfig>{
                        navigation: this.widget.model,

                        onSave: () => {
                            stage.close();
                            this.onChange();
                        },

                        onCancel: () => stage.close()
                    }
                }),

                lock: true
            });

            return () => stage.close();
        });
    }

    toggleState = () => {
        this.isUserLoggedIn.toggle();
    }

    private onChange() {
        events.communityWidgetSettingsAreChanged.trigger(this.widget);
    }
}